const netsuiteAccount = (key, label, acctNumber = '', acctName = '') => ({
  key, label, acctNumber, acctName,
});

export const NETSUITE_TABS = [
  {
    key: 'subsidiary',
    title: 'Subsidiary',
  },
  {
    key: 'bill_operadores',
    title: 'Bill Operadores',
    accounts: [
      netsuiteAccount('accounts_payable_operadores', 'Cuentas por Pagar Operadores', '2003', 'Cuentas por Pagar Operadores'),
      netsuiteAccount('comision_recorrido_b2c', 'Comisión Recorrido B2C', '4007', 'Comisión Recorrido B2C'),
      netsuiteAccount('comision_recorrido_b2b', 'Comisión Recorrido B2B', '40076', 'Comisión Recorrido B2B'),
      netsuiteAccount('gasto_operador', 'Gasto Operador', '6040', 'Gasto Operador'),
      netsuiteAccount('iva_comision', 'IVA Comisión', '21813', 'IVA Comisión'),
      netsuiteAccount('departamento_b2c', 'Departamento B2C', '6', 'Product B2C'),
      netsuiteAccount('departamento_b2b', 'Departamento B2B', '25', 'Product B2B'),
      netsuiteAccount('ajuste_a_favor', 'Ajuste a favor', '2159', 'Ajuste a favor'),
    ],
  },
  {
    key: 'credit_bill_operadores',
    title: 'Credit Bill Operadores',
    accounts: [
      netsuiteAccount('accounts_payable_operadores', 'Cuentas por Pagar Operadores', '2003', 'Cuentas por Pagar Operadores'),
      netsuiteAccount('gasto_operador', 'Gasto Operador', '6040', 'Gasto Operador'),
      netsuiteAccount('departamento_b2c', 'Departamento B2C', '6', 'Product B2C'),
      netsuiteAccount('departamento_b2b', 'Departamento B2B', '25', 'Product B2B'),
      netsuiteAccount('descuentos_servicios', 'Descuentos Servicios', '2153', 'Other Current Liabilities'),
      netsuiteAccount('prestamos_operadores', 'Préstamos Operadores', '1225', 'Advances - Operators'),
      netsuiteAccount('ajuste_en_contra', 'Ajuste en contra', '2159', 'Refunds Payable'),
    ],
  },
  {
    key: 'invoice',
    title: 'Invoice',
    accounts: [
      netsuiteAccount('cuentas_por_cobrar_medios_pago', 'Cuentas por Cobrar Medios de Pago', '11002', 'Cuentas por Cobrar Medios de Pago'),
      netsuiteAccount('ingreso_medio_pago', 'Ingreso Medio de Pago', '6039', 'Ingreso Medio de Pago'),
      netsuiteAccount('ingreso_axa', 'Ingreso Axa', '4001', 'Ingreso Axa'),
      netsuiteAccount('axa_por_pagar', 'Axa por Pagar', '1109', 'Axa por Pagar'),
      netsuiteAccount('cuota_transporte_b2c', 'Cuota Transporte B2C', '40071', 'Cuota Transporte B2C'),
      netsuiteAccount('cuota_transporte_paypal', 'Cuota Transporte PayPal', '40072', 'Cuota Transporte PayPal'),
      netsuiteAccount('cuota_transporte_b2b', 'Cuota Transporte B2B', '40073', 'Cuota Transporte B2B'),
      netsuiteAccount('cuota_transporte_otro', 'Cuota Transporte otro motivo', '40077', 'Cuota Transporte otro motivo'),
      netsuiteAccount('rr_fee', 'RR Fee', '4013', 'RR Fee'),
      netsuiteAccount('iva_rr_fee', 'IVA RR Fee', '21813', 'IVA RR Fee'),
    ],
  },
  {
    key: 'credit_memo_medio_pago',
    title: 'Credit Memo - Medio de Pago',
    accounts: [
      netsuiteAccount('cuentas_por_cobrar_medios_pago', 'Cuentas por Cobrar Medios de Pago', '11002', 'Cuentas por Cobrar Medios de Pago'),
      netsuiteAccount('ingreso_medio_pago', 'Ingreso Medio de Pago', '6039', 'Ingreso Medio de Pago'),
      netsuiteAccount('cuota_transporte_b2c', 'Cuota Transporte B2C', '40071', 'Cuota Transporte B2C'),
      netsuiteAccount('cuota_transporte_paypal', 'Cuota Transporte PayPal', '40072', 'Cuota Transporte PayPal'),
      netsuiteAccount('cuota_transporte_b2b', 'Cuota Transporte B2B', '40073', 'Cuota Transporte B2B'),
      netsuiteAccount('cuota_transporte_otro', 'Cuota Transporte otro motivo', '40077', 'Cuota Transporte otro motivo'),
    ],
  },
  {
    key: 'bill_axa',
    title: 'Bill AXA',
    accounts: [
      netsuiteAccount('axa_por_pagar', 'Axa por Pagar', '1109', 'Axa por Pagar'),
    ],
  },
  {
    key: 'credit_memo_cupones',
    title: 'Credit Memo - Cupones',
    accounts: [
      netsuiteAccount('pasivo_cupones', 'Pasivo Cupones'),
      netsuiteAccount('ingreso_medio_pago', 'Ingreso Medio de Pago', '6039', 'Ingreso Medio de Pago'),
      netsuiteAccount('cuota_transporte_b2c', 'Cuota Transporte B2C', '40071', 'Cuota Transporte B2C'),
      netsuiteAccount('cuota_transporte_paypal', 'Cuota Transporte PayPal', '40072', 'Cuota Transporte PayPal'),
      netsuiteAccount('cuota_transporte_b2b', 'Cuota Transporte B2B', '40073', 'Cuota Transporte B2B'),
      netsuiteAccount('cuota_transporte_otro', 'Cuota Transporte otro motivo', '40077', 'Cuota Transporte otro motivo'),
    ],
  },
];

export default NETSUITE_TABS;
